import { Button, Stack, Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTextField from "../../components/commoncomponents/CustomTextField";
import StyledBanner from "../../components/commoncomponents/StyledBanner";
import WelcomeCard from "../../components/commoncomponents/WelcomeCard";
import utilities from "../../utility/utilities";
import { validations } from "../../utility/constants/errors/messages";
import CustomDialog from "../../components/commoncomponents/CustomDialog";
import { dialogContent } from "../../utility/message";
import axios from "axios";
import { ifacSecurityURL } from "../../utility/apiURLS";
import { getAuthToken } from "../../utility/tokenUtility";
import { encryptionKey } from "../../utility/secretKeys";

const VendorRegister = () => {
    const token = getAuthToken("id_token");
    const config = {
        headers: {
            // Attach bearer token to request header
            Authorization: `Bearer ${token}`,
        },
    };
    const navigate = useNavigate();
    const location = useLocation();
    const { companyId, vendorId, vendorName } = location.state
    const vendorUserTypeId = 4
    const initialState ={
        username: "",
        firstname: "",
        lastname: "",
        email: ""
    }

    const [form, setForm] = useState(initialState);

    const [errors, setErrors] = useState({});
    const [isChanged, setIsChanged] = useState(false);
    const [isAddNew, setIsAddNew] = useState(false);
    const [openConirmDialog, setOpenConfirmDialog] = useState(false)
    const [openInfoDialog, setOpenInfoDialog] = useState(false)
    const [contentDialog, setContentDialog] = useState("")
    const [enableSubmit, setEnableSubmit] = useState(true)
    const [facilities, setFacilities] = useState([])
    const [roleId, setRoleId] = useState("")

    // Handle input changes
    const handleChange = (value, name) => {
        setForm((prev) => ({ ...prev, [name]: value }));
        setIsChanged(true);

        // Clear errors when user types
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    // Validate form fields
    const validateForm = () => {
        let newErrors = {};

        if (!form.username) newErrors.username = "Username is required";
        else if (!utilities.validateTextFieldCode(form.username)) newErrors.username = validations.textfieldCode;

        if (!form.firstname) newErrors.firstname = "First Name is required";
        else if (!utilities.validateTextField(form.firstname)) newErrors.firstname = validations.textfield;

        if (!form.lastname) newErrors.lastname = "Last Name is required";
        else if (!utilities.validateTextField(form.lastname)) newErrors.lastname = validations.textfield;

        if (!form.email) newErrors.email = "Email is required";
        else if (!utilities.validateEmail(form.email)) newErrors.email = validations.email;

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // Handle form submission
    const handleSubmit = () => {
        if (validateForm()) {
            handlesave()
        }
    };

    // Handle Addnew Action
    const handleAddNew = () => {
        if (isChanged) {
            setIsAddNew(true);
            setOpenConfirmDialog(true);
            setContentDialog(dialogContent.modified);
        } else {
            setDeafault();
        }
    }

    // Handle cancel action
    const handleCancel = () => {
        if (!isChanged) {
            navigate("/vendorLogin");
        } else {
            setOpenConfirmDialog(true)
        }
    }
    const handleDialogClose = () => {
        setOpenConfirmDialog(false)
        setOpenInfoDialog(false)
        if (isAddNew) {
            setIsAddNew(false);
        }
    }

    const handleConfirm = () => {
        if (isAddNew) {
            setDeafault();
        } else {
            navigate("/vendorLogin");

        }
    }

    const setDeafault = () => {
        setForm(initialState)
        setEnableSubmit(true);
        setErrors({});
        setIsAddNew(false);
        setIsChanged(false);
        setOpenConfirmDialog(false)
    };

    const fetchRoleOptions = async (companyId, userTypeId) => {
        try {
            const config = {
                headers: {
                    // Attach bearer token to request header
                    Authorization: `Bearer ${token}`,
                },
            };
            const roleResponse = await axios.get(`${ifacSecurityURL}/api/GraphUserRegistration/GetSecUserTypeList/${companyId}/${userTypeId}?size=1000`, config);
            const vendorRole = roleResponse.data[0]
            setRoleId(vendorRole ? vendorRole.roleId : null);
        }
        catch (error) {
            console.error("Error fetching service options:", error);
        }
    };

    const getFacilities = async (companyId) => {
        if (companyId)
            try {
                const config = {
                    headers: {
                        // Attach bearer token to request header
                        Authorization: `Bearer ${token}`,
                    },
                };
                const facilityRes = await axios.get(`${ifacSecurityURL}/api/GraphUserRegistration/GetSecregionListByCompanyId/${companyId}?size=1000`, config);
                setFacilities(facilityRes.data)
            }
            catch (error) {
                console.error("Error fetching service options:", error);
            }
    };

    const resetPassword = async () => {
        try {
            const hostnameAndPort = `${window.location.hostname}:${window.location.port}`;
            const response = await axios.post(`${ifacSecurityURL}/api/account/forgot-password`, { email: form.email, applicationSecurityKey: encryptionKey, url: hostnameAndPort });
            if (response.status === 200) {
                setOpenInfoDialog(true);
                setContentDialog(dialogContent.reset);
                setIsChanged(false);
                setOpenInfoDialog(true);
                setEnableSubmit(false);
            }
        }
        catch (error) {
            console.error("Error fetching service options:", error);
        }
    };


    const handlesave = async () => {
        const postDataUser = {
            id: "",
            login: form.username || null,
            username: form.username || null,
            firstname: form.firstname || null,
            lastname: form.lastname || null,
            isDeleted: false,
            password: "Welcome@123",
            roleId: roleId || null,
            theme: "default",
            widgets: "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20|5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20",
            isActive: true,
            createdBy: vendorId,
            lastModifiedBy: "",
            activated: true,
            email: form.email
        };

        const userDetails = {
            id: "",
            createdBy: vendorId,
            modifiedBy: vendorId,
            userempno: form.username,
            departmentId: null,
            staffStatusId: 1,
            userTypeId: vendorUserTypeId,
            userId: "",
            isDeleted: false
        }
        const postUserDetails = facilities.map((facility) => {
            facility.roleId = roleId;
            facility.id = ""
            return {
                ...userDetails,
                ...facility,
            }
        })

        const endpointusers = `${ifacSecurityURL}/api/register`;
        const endpointuserdetailspost = `${ifacSecurityURL}/api/secuserdetails/`;

        try {
            const [empRes, emailRes] = await Promise.all([
                axios.get(`${ifacSecurityURL}/api/GraphUserRegistration/GetSecuserregisterEmpCheck/${form.username}`, config),
                axios.get(`${ifacSecurityURL}/api/GraphUserRegistration/EmailCheck/${form.email}`, config)
            ]);

            if (empRes?.status === 200 && emailRes?.status === 200) {
                const response = await postMethod(endpointusers, postDataUser, config);

                if (response?.status === 201) {
                    const data = postUserDetails.map((user) => ({
                        ...user,
                        userId: response?.data?.id
                    }));

                    const res = await postMethod(endpointuserdetailspost, data, config);

                    if (res?.status === 200) {
                        resetPassword();
                    }
                }
            }
        } catch (error) {
            if (error?.response?.status === 400) {
                setOpenInfoDialog(true);
                setContentDialog(error.response.data?.detail || validations.default);
            }
            console.error("Error in user registration:", error);
        }


    };

    const postMethod = async (endpoint, postData, config) => {
        try {
            const result = await axios({
                method: "post",
                url: endpoint,
                data: postData,
                headers: config.headers,
            });
            return result;
        } catch (error) {
            if (error.response.status === 400) {
                setOpenInfoDialog(true);
                setContentDialog(error.response.data.detail || validations.default);
            }
            console.log(error);
        }
    };

    useEffect(() => {
        if (companyId) {
            fetchRoleOptions(companyId, vendorUserTypeId)
            getFacilities(companyId)
        }

    }, [companyId])

    return (
        <>
            <StyledBanner>
                <WelcomeCard>
                    <Box textAlign="center">
                        <Typography variant="h2" color="text.secondary">
                            Vendor Registration
                        </Typography>
                    </Box>

                    <Stack gap={2}>
                        <Box>
                            <CustomTextField
                                label="Vendor Name"
                                disabled
                                value={vendorName}
                            />
                        </Box>
                        <Box>
                            <CustomTextField
                                label="Username"
                                name="username"
                                isMandatoryField
                                value={form.username}
                                onChange={(value) => handleChange(value, "username")}
                                error={!!errors.username}
                                errorMessage={errors.username}
                                disabled={!enableSubmit}

                            />
                        </Box>

                        <Box>
                            <CustomTextField
                                label="First Name"
                                name="firstname"
                                isMandatoryField
                                value={form.firstname}
                                onChange={(value) => handleChange(value, "firstname")}
                                error={!!errors.firstname}
                                errorMessage={errors.firstname}
                                disabled={!enableSubmit}
                            />
                        </Box>


                        <Box>
                            <CustomTextField
                                label="Last Name"
                                name="lastname"
                                isMandatoryField
                                value={form.lastname}
                                onChange={(value) => handleChange(value, "lastname")}
                                error={!!errors.lastname}
                                errorMessage={errors.lastname}
                                disabled={!enableSubmit}
                            />
                        </Box>

                        <Box>
                            <CustomTextField
                                label="Email"
                                name="email"
                                isMandatoryField
                                value={form.email}
                                onChange={(value) => handleChange(value, "email")}
                                error={!!errors.email}
                                errorMessage={errors.email}
                                disabled={!enableSubmit}
                            />
                        </Box>

                    </Stack>

                    <Stack direction="row" justifyContent="flex-end" mt={3} spacing={2}>
                        <Button variant="contained" onClick={handleSubmit} disabled={!enableSubmit}>
                            Register
                        </Button>
                        <Button variant="contained" onClick={handleAddNew} >
                            Add New
                        </Button>
                        <Button variant="outlined" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </Stack>
                </WelcomeCard>
            </StyledBanner>
            <CustomDialog
                confirmBtn={"Ok"}
                open={openInfoDialog}
                content={contentDialog}
                onConfirm={handleDialogClose}
            />
            <CustomDialog
                open={openConirmDialog}
                onConfirm={handleConfirm}
                content={dialogContent.modified}
                cancelBtn={"No"}
                confirmBtn={"Yes"}
                onClose={handleDialogClose}
            />
        </>

    );
};

export default VendorRegister;
